import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import DraggableButton from '@components/draggable/DraggableButton';
import { ScheduleSelectors } from '@redux/ScheduleRedux';
import { stripePriceConverter } from '@services/transform';

const ButtonWrapper = styled(DraggableButton)`
  position: relative;

  flex: 1;
  margin-right: 16px;
  &:last-child {
    margin-right: 0px;
  }
`;

function ServiceTypeSelector(props) {
  const { data, serviceType, numOfItems, price, ...restProps } = props;
  const { title, icon } = data;

  const isDisabled = numOfItems == 0;

  return (
    <ButtonWrapper
      key={serviceType}
      title={title}
      contentMode="vertical"
      subtitle={`$${stripePriceConverter(price)}`}
      icon={icon}
      dragCount={numOfItems}
      disabled={isDisabled}
      {...restProps}
    />
  );
}

ServiceTypeSelector.propTypes = {
  data: PropTypes.object,
  serviceType: PropTypes.string.isRequired,
  numOfItems: PropTypes.number,
  hideTitle: PropTypes.bool,
  price: PropTypes.number
};

const mapStatesToProps = (state, ownProps) => ({
  numOfItems: ScheduleSelectors.selectNumOfServiceType(
    state,
    ownProps.serviceType
  )
});

export default connect(mapStatesToProps)(ServiceTypeSelector);
